var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binds-card-media-cover",class:_vm.coverClasses},[_vm._t("default"),(_vm.bindsTextScrim)?_c('div',{ref:"backdrop",staticClass:"binds-card-backdrop",style:(_vm.coverStyles)}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }